import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, number, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);
const list = ['Praha', 'Brno', 'Olomouc'];

stories
	.addDecorator(withKnobs)
	.add('Select', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-select v-bind="$props" validationProperty="value" :value.sync="value" :selectList="selectList" />
		</dms-form>
		`,
		data() {
			return {
				value: null,
			};
		},
		props: {
			showLabel: {
				default: boolean('Zobrazit label', true),
			},
			label: {
				default: text('Label', 'Město'),
			},
			placeholder: {
				default: text('Placeholder', 'Zvolte město'),
			},
			isRequired: {
				default: boolean('Povinné pole', false),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
		computed: {
			rules() {
				return {
					value: [
						{
							required: this.isRequired, trigger: ['change', 'blur'],
						},
					],
				};
			},
			selectList() {
				return list.map((val, index) => ({ Text: val, Value: index }));
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}))
	.add('MultiSelect', () => ({
		template: '<dms-form :model="$data" :rules="rules"><dms-select v-bind="$props" validationProperty="value" multiple :value.sync="value" :selectList="selectList" /></dms-form>',
		data() {
			return {
				value: [],
			};
		},
		props: {
			showLabel: {
				default: boolean('Zobrazit label', true),
			},
			label: {
				default: text('Label', 'Město'),
			},
			placeholder: {
				default: text('Placeholder', 'Zvolte města'),
			},
			isRequired: {
				default: boolean('Povinné pole', false),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
			min: {
				default: number('Min počet možností', 2),
			},
		},
		computed: {
			rules() {
				return {
					value: [
						{
							required: this.isRequired, trigger: ['change', 'blur'],
						},
						{
							type: 'array', min: this.min, message: `Vyberte alespoň ${this.min} možnosti.`,
						},
					],
				};
			},
			selectList() {
				return list.map((val, index) => ({ Text: val, Value: index }));
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
